import { Component } from '@angular/core';

@Component({
    templateUrl: './summary-onsite-section.component.html',
    standalone: false
})
export class SummaryOnsiteSectionComponent {

  constructor() {}

}
